import { getBaseRole } from '@/helpers/customRoles';
import { taskTrackerProjectsApi } from '@pages/Admin/TaskTrackerCRM/api/taskTracker.projects.api'
import { isTaskTrackerCrmSalesDepartmentProject } from '@pages/Admin/TaskTrackerCRM/lib/taskTrackerCrmSalesDepartment.utils'
import {
  hasAnotherProjectAdminBesides,
  mapProjectMemberToDraft,
} from '@pages/Admin/TaskTrackerCRM/lib/projectMember.utils'

export type HeadOfSalesSoleProjectAdminCheck = {
  blocked: boolean
  projectTitle?: string
}

/**
 * РОП — админ систем-проекта CRM «Отдел продаж».
 * Если он единственный админ — снимать роль / увольнять нельзя.
 */
export const checkHeadOfSalesSoleProjectAdmin = async (
  userId: number | string,
): Promise<HeadOfSalesSoleProjectAdminCheck> => {
  const targetUserId = Number(userId)
  if (!Number.isFinite(targetUserId) || targetUserId <= 0) {
    return { blocked: false }
  }

  const projects = await taskTrackerProjectsApi.getProjects()
  const salesProjects = (projects ?? []).filter((project) =>
    isTaskTrackerCrmSalesDepartmentProject(project?.systemKey),
  )

  for (const project of salesProjects) {
    const details = await taskTrackerProjectsApi.getProject(project.id)
    const members = (details?.members ?? []).map(mapProjectMemberToDraft)
    const self = members.find((member) => member.userId === targetUserId)

    if (!self || getBaseRole(self.role) !== 'admin') continue

    if (!hasAnotherProjectAdminBesides(members, targetUserId)) {
      return {
        blocked: true,
        projectTitle: details?.title || project.title || 'Отдел продаж',
      }
    }
  }

  return { blocked: false }
}
